import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Manufacturer } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, Manufacturer>,
    'queryKey' | 'queryFn'
  >;
}

export const useManufacturerRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, Manufacturer>(
    [Entities.Manufacturers, id],
    async () => {
      const { data } = await api.v1AdminManufacturersManufacturerIdGet(id)
      return data
    },
    {
      ...options,
    },
  )
}
